/**
 * @fileoverview GET handler for the "/:app_group_id/canvas/:workflow_id/step/:step_id/messages" endpoint
 */
import { reactQueryFetcherAdapter } from "@dashboardApi/apis/reactQueryFetcherAdapters";

import fetch from "@lib/fetch";

import { appGroupIdCanvasWorkflowIdStepStepIdMessages } from "./constants";
import type { MessagesResult } from "./types";

export const getMessages = reactQueryFetcherAdapter(
  appGroupIdCanvasWorkflowIdStepStepIdMessages,
  (signal: AbortSignal, appGroupId: string, workflowId: string, stepId: string): Promise<MessagesResult> => {
    return fetch(`/${appGroupId}/canvas/${workflowId}/step/${stepId}/messages`, "GET", {}, { signal });
  }
);
